import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { PageStartComponent } from '../components/page/page-start.component';
import { HeroTeaserApiService } from '../services/api/hero-teaser.service';
import { MagazineApiService } from '../services/api/magazine.service';
import { NewspaperApiService } from '../services/api/newspaper.service';
import { PageTeaserApiService } from '../services/api/page-teaser.service';
import { HeroTeaserEffects } from '../state/hero-teaser/hero-teaser.effects';
import { HeroTeaserFacade } from '../state/hero-teaser/hero-teaser.facade';
import { HeroTeaserSelector } from '../state/hero-teaser/hero-teaser.selectors';
import { MagazineEffects } from '../state/magazine/magazine.effects';
import { MagazineFacade } from '../state/magazine/magazine.facade';
import { MagazineSelector } from '../state/magazine/magazine.selectors';
import { NewspaperEffects } from '../state/newspaper/newspaper.effects';
import { NewspaperFacade } from '../state/newspaper/newspaper.facade';
import { NewspaperSelector } from '../state/newspaper/newspaper.selectors';
import { PageTeaserEffects } from '../state/page-teaser/page-teaser.effects';
import { PageTeaserFacade } from '../state/page-teaser/page-teaser.facade';
import { PageTeaserSelector } from '../state/page-teaser/page-teaser.selectors';
import { RegionSelector } from '../state/region/region.selectors';
import { SharedModule } from './shared.module';

@NgModule({
	declarations: [PageStartComponent],
	imports: [
		CommonModule,
		MatButtonModule,
		MatDatepickerModule,
		MatFormFieldModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatIconModule,
		MatInputModule,
		ReactiveFormsModule,
		FormsModule,
		EffectsModule.forFeature([HeroTeaserEffects, PageTeaserEffects, NewspaperEffects, MagazineEffects]),
		RouterModule.forChild([
			{
				path: '',
				component: PageStartComponent,
			},
		]),
		SharedModule,
	],
	providers: [
		HeroTeaserApiService,
		HeroTeaserSelector,
		HeroTeaserFacade,

		PageTeaserApiService,
		PageTeaserSelector,
		PageTeaserFacade,

		NewspaperApiService,
		NewspaperSelector,
		NewspaperFacade,

		MagazineApiService,
		MagazineSelector,
		MagazineFacade,

		RegionSelector,
	],
})
export class StartpageModule {}
